module.exports = __webpack_public_path__ + "img/mission-flow.126174cc.svg";